<template>
    <div class="clearfix x-tabs"
         :class="{ 'x-tabs--intent': intent }">
        <div v-for="(item, index) in items"
             class="x-tabs__item"
             :key="index"
             :data-value="item.value"
             :class="{ 'x-tabs__item--active': item.value === current }"
             :data-log='item.tracker'
             @click="change(item.value)">{{ item.label }}<div class="x-tabs__line"></div></div>
    </div>
</template>

<script>
export default {
    name: 'XTabs',

    props: {
        value: {},
        intent: {
            type: Boolean,
            default: true
        },
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    computed: {
        current() {
            if (this.value) {
                return this.value
            }
            return this.items[0] && this.items[0].value
        }
    },
    methods: {
        change(value) {
            this.$emit('input', value)
            this.$emit('change', value)
        }
    }
}
</script>

<style lang="less" scoped>
@import '~common/less/var.less';
.x-tabs {
    border-bottom: 3px solid @bgcolor-page;
    &--intent {
        padding: 0 20px;
    }
    &__item {
        position: relative;
        float: left;
        padding: 20px;
        font-size: 15px;
        line-height: 1;
        cursor: pointer;
        color: @color-gray;
        &:hover,&--active {
            color: @color-blue;
        }
        &--active {
            .x-tabs__line {
                display: block;
            }
        }
    }
    &__line {
        position: absolute;
        bottom: -3px;
        width: 32px;
        height: 3px;
        background: @color-blue;
        left: 50%;
        margin-left: -16px;
        display: none;
    }
}
</style>

